import { render, staticRenderFns } from "./BookingFlightRouteCollapse.vue?vue&type=template&id=4a2bb960&scoped=true&"
import script from "./BookingFlightRouteCollapse.vue?vue&type=script&lang=js&"
export * from "./BookingFlightRouteCollapse.vue?vue&type=script&lang=js&"
import style0 from "./BookingFlightRouteCollapse.vue?vue&type=style&index=0&id=4a2bb960&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2bb960",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VIcon,VRow,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a2bb960')) {
      api.createRecord('4a2bb960', component.options)
    } else {
      api.reload('4a2bb960', component.options)
    }
    module.hot.accept("./BookingFlightRouteCollapse.vue?vue&type=template&id=4a2bb960&scoped=true&", function () {
      api.rerender('4a2bb960', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Booking/FlightDetails/BookingFlightRouteCollapse.vue"
export default component.exports